import React from 'react';
import { ChefHat, Plus, Pencil, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { MENU_CATEGORIES } from './diningConstants';

export function MenuItemsSection({ 
    menuItems, 
    onAddItem, 
    onEditItem, 
    onDeleteItem 
}) {
    return (
        <div className="space-y-6" data-testid="menu-items-section">
            <div className="flex justify-between items-center">
                <div>
                    <h2 className="text-2xl font-bold">Menu Items</h2>
                    <p className="text-muted-foreground">{menuItems.length} items in menu</p>
                </div>
                <Button onClick={onAddItem} className="bg-rose-600 hover:bg-rose-700" data-testid="add-menu-item-btn">
                    <Plus className="w-4 h-4 mr-2" />
                    Add Item
                </Button>
            </div>
            
            {/* Group by category */}
            {MENU_CATEGORIES.map(cat => {
                const items = menuItems.filter(i => i.category === cat.value);
                if (items.length === 0) return null;
                return (
                    <div key={cat.value} className="space-y-3">
                        <h3 className="font-semibold text-lg text-stone-700 border-b pb-2">{cat.label}s</h3>
                        {items.map(item => (
                            <div key={item.id} className="bg-white rounded-xl p-4 border border-stone-200 flex items-center justify-between" data-testid={`menu-item-${item.id}`}>
                                <div className="flex-1">
                                    <div className="flex items-center gap-2 flex-wrap">
                                        <span className="font-medium text-stone-800">{item.name}</span>
                                        {item.is_vegetarian && <span className="text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-700">V</span>}
                                        {item.is_vegan && <span className="text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-700">VG</span>}
                                        {item.is_gluten_free && <span className="text-xs px-2 py-0.5 rounded-full bg-amber-100 text-amber-700">GF</span>}
                                        {!item.is_available && <span className="text-xs px-2 py-0.5 rounded-full bg-gray-200 text-gray-500">Unavailable</span>}
                                    </div>
                                    <p className="text-sm text-stone-500 mt-1">{item.description}</p>
                                    <p className="text-rose-600 font-medium mt-1">{item.price}</p>
                                </div>
                                <div className="flex gap-2">
                                    <Button variant="outline" size="sm" onClick={() => onEditItem(item)} data-testid={`edit-menu-${item.id}`}>
                                        <Pencil className="w-4 h-4" />
                                    </Button>
                                    <Button variant="destructive" size="sm" onClick={() => onDeleteItem(item)} data-testid={`delete-menu-${item.id}`}>
                                        <Trash2 className="w-4 h-4" />
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </div>
                );
            })}
            
            {menuItems.length === 0 && (
                <div className="bg-stone-100 rounded-xl p-12 text-center">
                    <ChefHat className="w-12 h-12 text-stone-300 mx-auto mb-3" />
                    <p className="text-stone-500 mb-4">No menu items yet</p>
                    <Button onClick={onAddItem} className="bg-rose-600 hover:bg-rose-700">
                        Add First Menu Item
                    </Button>
                </div>
            )}
        </div>
    );
}

export default MenuItemsSection;
